import React, { useEffect, useState } from 'react';
import { NewFlag } from '@components/NewFlag';
import { VimeoVideo } from '@components/VimeoVideo';
import { VIDEO_ASSETS } from './BabyRegistry.constants';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';
import {
  SectionWrapper,
  LottieContainer,
  StyledTextPairing,
  TextContainer,
  ExploreButton,
  VideoContainer,
  EyebrowWrapper,
} from './BabyRegistry.styles';
import { useTranslation } from 'react-i18next';

interface BabyRegistryProps {
  page: MarcomPageName;
}

export const BabyRegistry: React.FC<BabyRegistryProps> = ({ page }) => {
  const isMobile = useThemeMediaQuery('below_sm');
  const [videoAssets, setVideoAssets] = useState(VIDEO_ASSETS.mobile);

  useEffect(() => setVideoAssets(isMobile ? VIDEO_ASSETS.mobile : VIDEO_ASSETS.desktop), [isMobile]);

  const { t } = useTranslation('home');
  const { title, body, linkText, link } = t('babyRegistry');

  return (
    <SectionWrapper paddingBottom={[8, 0]} alignItems={['flex-end', 'center']}>
      <TextContainer paddingY={[8, 0]}>
        <LottieContainer flexDirection="column" justifyContent={['flex-start', 'center']} alignItems={['center', 'flex-start']}>
          <EyebrowWrapper>
            <NewFlag
              flagColor="white"
              flagBackgroundColor="accentBlue4"
              belowSm={{ flagColor: 'white', flagBackgroundColor: 'accentBlue4' }}
              speed={1.5}
              size={80}
            />
          </EyebrowWrapper>
          <StyledTextPairing
            titleVariant="calloutHed40Bold"
            titleColor="mono1"
            titleTagName="h3"
            title={title}
            body={body}
            bodyVariant="dek20"
            bodyColor="mono12"
            marginBottom={6}
            alignment={['center', 'left']}
            textAlign={['center', 'left']}
          />
          <ExploreButton id={`${page}BabyRegistryBtn`} forwardedAs="a" href={link} variant="secondaryMono" rounded>
            {linkText}
          </ExploreButton>
        </LottieContainer>
      </TextContainer>
      <VideoContainer>
        <LazyLoadWrapper>
          <VimeoVideo
            aspectRatio={9 / 16}
            title={title}
            embedUrl={videoAssets.url}
            posterUrl={videoAssets.poster}
            autoPlay
            background
            muted
            controls={false}
            loop
            autoPause={false}
            cover
            posterOptimization="mild"
            alt="baby-registry"
          />
        </LazyLoadWrapper>
      </VideoContainer>
    </SectionWrapper>
  );
};
